import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router";

const ERPCaseStudy = () => (
  <Box>
    <Typography variant={"h2"}>ERP Case Study</Typography>
    <Typography variant={"body1"}>Case Study body copy here</Typography>
    <Button
      component={Link}
      to="/onboarding"
      variant="contained"
      color="primary"
    >
      Personalize
    </Button>
  </Box>
);

export default ERPCaseStudy;
